/** API route map: URLS.Controller.JobNotes */
export const JobNotes = {
      Name: 'JobNotes/',
      GetAll: 'job-notes',
      AddNote: 'add-job-note',
      ShareJobNote: 'share',
      UpdateJobNote: 'update',
      DeleteJobNote: 'delete/',
};
